import axios from 'axios';
import { sessionTokenKey } from './../shared/constants';
import {
  getStoredValue,
  getStoredSessionValue,
} from '../shared/utils/localStorage';

export const getPercentage = (value, totalValue) => {
  try {
    if (totalValue == 0) {
      return 0;
    }
    return Math.floor((value / totalValue) * 100).toFixed(0);
  } catch (err) {
    console.error('getPercentage', { err, value, totalValue });
  }
};

export const getDataIndexByPropName = (data, propName, value) => {
  try {
    return data.findIndex((item) => {
      return item[propName] === value;
    });
  } catch (err) {
    console.error('getDataIndexByPropName', { err, data, propName, value });
  }
};

export const getListDataById = (data, propName, id) => {
  try {
    return data.filter((item) => item[propName] === id);
  } catch (err) {
    console.error('getListDataById', { err, data, propName, id });
  }
};

export const hasData = (data) => {
  try {
    return data && !!data;
  } catch (err) {
    console.error('hasData', { err, data });
  }
};

export const getProductAttribute = (data, key, noDataPlaceholderText) => {
  try {
    const attr = data && getListDataById(data.attributes || [], 'name', key)[0];
    return attr ? attr.value : noDataPlaceholderText;
  } catch (err) {
    console.error('getProductAttribute', {
      err,
      data,
      key,
      noDataPlaceholderText,
    });
  }
};

export const toTitleCase = (val) => {
  const value = val || '';
  if (typeof value !== 'string') throw new Error('Argument must be a string');

  return value.trim().replace(/\w\S*/g, (txt) => {
    if (txt.length === 1) return txt.toUpperCase();
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const convertArrayToObject = (data, key) => {
  try {
    return data.reduce(
      (obj, item) => Object.assign(obj, { [item[key]]: item.value }),
      {},
    );
  } catch (err) {
    console.error('convertArrayToObject', { err, data, key });
  }
};

export const mapToObj = (strMap) => {
  let obj = Object.create(null);
  for (let [key, value] of strMap) {
    obj[key] = value;
  }
  return obj;
};

export const getSessionToken = () => getStoredSessionValue(sessionTokenKey);

export const apiHeaders = {
  headers: {
    'content-type': 'application/json',
  },
};

export const loadData = async (params, url) => {
  const sessionToken = getSessionToken();
  const mergedParams = JSON.stringify({
    sessionToken,
    ...params,
  });
  // console.log('loadData', url, mergedParams, apiHeaders)
  return await axios.post(url, mergedParams, apiHeaders);
};

export const toBoolean = (str) => {
  //https://stackoverflow.com/questions/3263161/cannot-set-boolean-values-in-localstorage
  if (typeof str === 'undefined' || str === null) {
    return false;
  }
  if (typeof str === 'string') {
    switch (str.toLowerCase()) {
      case 'false':
      case 'no':
      case '0':
      case '':
        return false;
      default:
        return true;
    }
  } else if (typeof str === 'number') {
    return str !== 0;
  } else {
    return true;
  }
};
